export default "__VITE_ASSET__CXJmafNn__"